import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";


const MAX_PLACES = Infinity;

const useRecentSearchPlaces = create(
    persist(
        (set) => ({
            places:  [],

            addPlace: (value, uniqueKey = "place_id", maxItems = MAX_PLACES) =>
                set((s) => {
                    const incoming = Array.isArray(value) ? value : [value];
                    const base     = Array.isArray(s.places) ? s.places : [];

                    if (!incoming.length) return s;

                    let merged;
                    if (uniqueKey) {
                        const map = new Map(base.map((item) => [item?.[uniqueKey], item]));
                        for (const item of incoming) {
                            if (item?.[uniqueKey] !== undefined) map.set(item[uniqueKey], item);
                        }
                        merged = [...map.values()];
                    } else {
                        merged = [...base, ...incoming];
                    }

                    if (Number.isFinite(maxItems) && merged.length > maxItems) {
                        merged = merged.slice(-maxItems);
                    }

                    if (merged === base) return s;
                    return { places: merged };
                }),

            clearPlaces: () => set({ places: [], options: [] }),
        }),
        {
            name:       "ngud-openstreet-place",
            storage:    createJSONStorage(() => localStorage),
            partialize: (state) => ({ places: state.places }),
        }
    )
);

export default useRecentSearchPlaces;
